module.exports = __webpack_public_path__ + "static/media/hourglass-half.0e4cecc3.svg";